import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box, Typography, Grid, Pagination, Container, Card, Modal, Button, InputAdornment, TextField, CircularProgress } from '@mui/material';
import  {Dialog, DialogContentText, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { format } from 'date-fns';
import { debounce, throttle } from 'lodash';
import LinearProgress from '@mui/material/LinearProgress';
import { Paper, Stack } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import toast from 'react-hot-toast';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import '../ServicesMenu/servicesMenu.css';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import CustomerAdminCard from './CustomerAdminCard';
import Slide from '@mui/material/Slide';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const useStyles = makeStyles((theme) => ({
    customerAdminDateTimePicker: {
        width: '200px',
        [theme.breakpoints.down('md')]: {
            width: '170px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '170px',
        },
    },
    customerAdminSearchPicker: {
        width: '256px',
        [theme.breakpoints.down('md')]: {
            width: '230px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '190px',
        },
    },
    headerTextFields: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '10px',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            display: 'grid',
            justifyContent: 'flex-start',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            display: 'grid',
            justifyContent: 'flex-start',
        },
    },
    handleSearchStyle: {
        display: 'flex',
        marginTop: '32px',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            marginTop: '1px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            display: 'flex',
            marginTop: '1px',
        },
    },
    MaterialReactTableCustomerSuperAdmin: {
        // [theme.breakpoints.down('md')]: {
        //     width: '1070px',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1150px',
        // },
        // [theme.breakpoints.down('lg')]: {
        //     width: '1070px',
        // },
    },
}));
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const CustomersAdmin = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const abortControllerRef = useRef(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [GetAllCustomers, setGetAllCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [getTotalCustomers, setGetTotalCustomers] = useState('');
    const [dateFilter, setdateFilter] = useState('');
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [selectedFilterValue, setSelectedFilterValue] = useState('');
    const [selectedRefer, setSelectedRefer] = useState('');
    const [currentPageRef, setCurrentPageRef] = useState(1);
    const [searchTermRefer, setSearchTermRefer] = useState('');
    const [IsLoadingRef, setIsLoadingRef] = useState(false);
    const [openConfirmationMandatory, setOpenConfirmationMandatory] = useState(false);
    const [switchLoading, setSwitchLoading] = useState(false);
    const [confirmationDataMandatory, setConfirmationDataMandatory] = useState({ id: null, SwitchCustomer: null });
    const [getReferCode, setGetReferCode] = useState([]);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const lastScrollTopRef = useRef(0);
    const searchRefBy = useRef('');

    const AllReferCode = async (currentPageRef, searchTermRefer = '', signal) => {
        try {
            setIsLoadingRef(true);
            const isPaginatedRef = true;
            const allUsers = true;

            const res = await LeadService.getReferCode(currentPageRef, searchTermRefer, isPaginatedRef, allUsers, signal);
            if (res.data.success) {
                // Transform the data to match Autocomplete's format
                const formattedData =
                    res?.data?.data?.data?.map((item) => ({
                        label: `${item?.name || ''} ${item?.last_name || ''}`,
                        value: item?.referral_code,
                    })) || [];

                setHasMore(res?.data?.data?.data?.length > 0);
                setGetReferCode((prevCodes) => [...prevCodes, ...formattedData]);
                setCurrentPageRef(currentPageRef);
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoadingRef(false);
        }
    };

    const debouncedAllReferCode = useCallback(
        // Use a debounced version of fetchLocations
        debounce((currentPageRef, searchTermRefer) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            AllReferCode(currentPageRef, searchTermRefer, abortController.signal);
        }, 300),
        []
    );

    useEffect(() => {
        debouncedAllReferCode(currentPageRef, searchTermRefer);
    }, [currentPageRef, searchTermRefer, debouncedAllReferCode]);

    const handleScroll = useCallback(
        debounce((e) => {
            if (loading || !hasMore) return; // If loading or no more data, do nothing

            const { scrollTop, scrollHeight, clientHeight } = e.target;
            const isScrollingDown = scrollTop > lastScrollTopRef.current;

            if (isScrollingDown && scrollTop + clientHeight >= scrollHeight - 5) {
                setCurrentPageRef((prevPage) => prevPage + 1);
            }

            lastScrollTopRef.current = scrollTop;
        }, 200), // Adjust debounce time as needed
        [loading, hasMore]
    );
    const handleInputChange = (event, value) => {
        searchRefBy.current = value;
        setSearchTermRefer(value);
        if (value.trim() !== '') {
            debouncedAllReferCode(1, value);
        } else {
            setCurrentPageRef(1);
            setHasMore(false);
        }
    };
    const getCustomers = async (
        currentPage,
        searchTerm,
        searchParam = { from_date: '', to_date: '' },
        selectedFilterValue,
        selectedRefer,
        signal
    ) => {
        try {
            setLoading(true);
            const res = await LeadService.GetAllCustomers(currentPage, searchTerm, searchParam, selectedFilterValue, selectedRefer, signal);
            if (res.data.success) {
                setGetAllCustomers(res?.data?.data?.data);
                setCurrentPage(res?.data?.data?.current_page);
                setTotalPages(Math.ceil(res?.data?.data?.total / res?.data?.data?.per_page));
                setGetTotalCustomers(res?.data?.totalCustomers);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledAllCustomers = useCallback(
        throttle((currentPage, searchTerm, dateFilter, selectedFilterValue, selectedRefer, signal) => {
            getCustomers(currentPage, searchTerm, dateFilter, selectedFilterValue, selectedRefer, signal);
        }, 2000),
        []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchAllCustomers = useCallback(
        debounce((currentPage, searchTerm, dateFilter, selectedFilterValue, selectedRefer) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledAllCustomers(currentPage, searchTerm, dateFilter, selectedFilterValue, selectedRefer, abortController.signal);
        }, 300),
        [throttledAllCustomers]
    );

    useEffect(() => {
        fetchAllCustomers(currentPage, searchTerm, dateFilter, selectedFilterValue, selectedRefer);
    }, [currentPage, searchTerm, fetchAllCustomers, dateFilter, selectedFilterValue, selectedRefer]);

    const handleSearchChange = (event) => {
        const newSearchValue = event.target.value;
        setSearchTerm(newSearchValue);
        if (newSearchValue !== null) {
            localStorage.setItem('searchTerm', JSON.stringify(newSearchValue));
        } else {
            localStorage.removeItem('searchTerm');
        }

    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handlOpenDeleteModal = (id) => {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    const handleNavigateCustomerDetails = (id) => {
        navigate(`/customers-details/${id}`);
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const handleOpenConfirmationModal = async (id, SwitchCustomer) => {
        // Open confirmation modal
        setConfirmationDataMandatory({ id, SwitchCustomer });
        setOpenConfirmationMandatory(true);
    };

    const handleConfirmationMandatory = async () => {
        const { id, SwitchCustomer } = confirmationDataMandatory;
        try {
            setSwitchLoading(true)
            const res = await LeadService.HandleSwitchAgentCustomer(id, SwitchCustomer);
            if (res.data.success) {
                toast.success(res.data.message);
                setOpenConfirmationMandatory(false);
                setSwitchLoading(false)
                fetchAllCustomers(currentPage, searchTerm, dateFilter, selectedFilterValue, selectedRefer);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const columns = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            size: 40,
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <div>
                        <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <span style={{ marginLeft: 10 }}>{row?.original?.organization_name}</span>
                    </div>
                </div>
            ),
            enableSorting: false,
            size: 10,
        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            accessorKey: 'customerName',
            header: 'Customer Name',
            size: 100,
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            muiTableHeadCellProps: {
                align: 'left',
            },
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            size: 140,
            // enableClickToCopy: true,
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            size: 80,
            enableSorting: false,
        },
        {
            accessorKey: 'import',
            header: 'Registered By',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.import;

                if (dateString === 'organization') {
                    return 'By System';
                } else if (dateString === 'self') {
                    return 'Self';
                } else {
                    return dateString; // Fallback for any other values or null/undefined
                }
            },
        },

        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: true,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        // {
        //     accessorKey: 'refer_by',
        //     header: 'Refer Code',
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 100,
        //     muiTableHeadCellProps: {
        //         sx: {
        //             fontSize: '14px',
        //         },
        //     },
        // },
        {
            accessorKey: 'lofty_user_id',
            header: 'Switch to Agent',
            size: 80,
            enableSorting: false,
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ row }) => {
                const { id, old_userid  } = row?.original;

                // Handler for switch toggle
                const handleToggle = () => {
                    const SwitchCustomer = 'agent';
                    handleOpenConfirmationModal(id, SwitchCustomer);
                };

                return (
                    <>
                        {/* Render the button and `old_userid` are null */}
                        {old_userid === null ? (
                            <Button
                                onClick={handleToggle}
                                variant="outlined"
                                color="info"
                                size="small"
                                style={{ fontSize: { sx: '10px', md: '10px', lg: '12px' }, borderRadius: '20px', cursor: 'pointer' }}
                            >
                                Switch to Agent
                            </Button>
                        ) : (
                            <span>Not Switchable</span>
                        )}
                    </>
                );
            },
        },
        {
            id: 'actions',
            enableSorting: false,
            header: 'See More',
            size: 100,
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>
                    <IconButton aria-label="view" onClick={() => handleNavigateCustomerDetails(row?.original?.id)}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <VisibilityIcon />
                        </div>
                    </IconButton>
                    {/* <IconButton
                        onClick={() => handlOpenDeleteModal(row?.original?.id)}
                        aria-label="delete">
                        <DeleteIcon sx={{ color: '#E71D36' }} />
                    </IconButton> */}
                </div>
            ),
        },
    ];

    const adjustOffsetForSendData = (date, offsetInHours) => {
        const dateObj = new Date(date);
        const utcDate = new Date(dateObj.toUTCString()); // Convert to UTC
        if (offsetInHours > 0) {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        } else {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        }
        return utcDate;
    };

    const formatDate = (date) => {
        return date ? dayjs(date).format('DD-MM-YYYY HH:mm:ss') : null;
    };

    const handleSearchClick = async (searchTerm) => {
        const currentDate = new Date();
        const formattedCurrentDate = formatDate(currentDate);

        if (!fromDate) {
            if (!toDate) {
                toast.error('Please select the to date.');
                return;
            }
        }

        if (fromDate === '') {
            return toast.error('please select the from data');
        } else if (toDate === '') {
            return toast.error('please select the to date');
        }

        if (toDate && fromDate && toDate.isBefore(fromDate)) {
            toast.error('Please select a to date later than the start date.');
            return;
        }

        const userOffset = getUserOffset();
        const formattedFromDate = formatDate(adjustOffsetForSendData(fromDate, userOffset));
        const formattedToDate = formatDate(adjustOffsetForSendData(toDate, userOffset));

        const searchParam = {
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };

        // Store from_date and to_date in local storage
        const SaveFilterDate = {
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };

        localStorage.setItem('SaveFilterDate', JSON.stringify(SaveFilterDate));
        if (fromDate !== null) {
            localStorage.setItem('fromDate', JSON.stringify(fromDate));
        }
        if (toDate !== null) {
            localStorage.setItem('toDate', JSON.stringify(toDate));
        }

        setdateFilter(searchParam);
        // await getCustomers(1, searchTerm, searchParam);   // when i commit this like dual Api call issue fixed
    };

    useEffect(() => {
        const savedFilterDate = localStorage.getItem('SaveFilterDate');
        if (savedFilterDate) {
            const { from_date, to_date } = JSON.parse(savedFilterDate);
            setdateFilter({ from_date, to_date });
        }
        const SaveFromDate = localStorage.getItem('fromDate');
        if (SaveFromDate) {
            setFromDate(dayjs(JSON.parse(SaveFromDate)));
        }
        const SaveToDate = localStorage.getItem('toDate');
        if (SaveToDate) {
            setToDate(dayjs(JSON.parse(SaveToDate)));
        }

        const savedFilterValue = localStorage.getItem('selectedFilterValue');
        if (savedFilterValue) {
            setSelectedFilterValue(JSON.parse(savedFilterValue));
        }

        const savedReferValue = localStorage.getItem('selectedRefer');
        if (savedReferValue) {
            setSelectedRefer(JSON.parse(savedReferValue));
        }

        const savedSearchTerm = localStorage.getItem('searchTerm');
        if (savedSearchTerm !== null) {
            setSearchTerm(JSON.parse(savedSearchTerm));
        }
    }, [selectedFilterValue, selectedRefer, searchTerm]);

    const handleClearAllState = () => {
        localStorage.removeItem('fromDate');
        localStorage.removeItem('toDate');
        localStorage.removeItem('SaveFilterDate');
        localStorage.removeItem('selectedFilterValue');
        localStorage.removeItem('selectedRefer');
        localStorage.removeItem('searchTerm');

        setFromDate('');
        setToDate('');
        setdateFilter('');
        setSearchTerm('');
        setSelectedFilterValue('');
        setSelectedRefer('');
    };
    const handleClear = () => {
        localStorage.removeItem('searchTerm');
        setSearchTerm('');
        setCurrentPage(1);
        fetchAllCustomers(1, '');
        localStorage.removeItem('selectedRefer');
        setSelectedRefer('');
    };

    const filterOptions = [
        { label: 'All', value: '' },
        { label: 'Self', value: 'self_signup' },
        { label: 'By System', value: 'by_system' },
    ];

    const HandleChangeFilter = (event, newValue) => {
        if (newValue) {
            const newFilterValue = newValue.value;
            setSelectedFilterValue(newFilterValue);
            localStorage.setItem('selectedFilterValue', JSON.stringify(newFilterValue));
        } else {
            setSelectedFilterValue(null);
            localStorage.removeItem('selectedFilterValue');
        }
    };
    const HandleChangeReferedByFilter = async (event, newValue) => {
        if (newValue) {
            const newFilterValue = newValue.value;
            setSelectedRefer(newFilterValue);
            localStorage.setItem('selectedRefer', JSON.stringify(newFilterValue));
        } else {
            setSelectedRefer(null);
            localStorage.removeItem('selectedRefer');
        }
    };
    return (
        <div style={{ mt: 4 }}>
            <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
            <Box>
                <CustomerAdminCard />
            </Box>
            <Box style={{ marginTop: '30px' }}>
                <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <Typography className="services-animated-text">
                            Customers
                        </Typography>
                    </div>
                </Box>

                <Box className={classes.headerTextFields}>
                    <Box
                        style={{
                            display: 'flex',
                            gap: '5px',
                            flexWrap: 'wrap'
                        }}
                    >
                        <Box>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                                </div>
                            </div>
                            <div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker']}>
                                        <DateTimePicker
                                            className={classes.customerAdminDateTimePicker}
                                            sx={{
                                                width: {
                                                    xs: "150px",
                                                    sm: "200px",
                                                    md: "250px"
                                                },
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                }, '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={fromDate}
                                            onChange={(newDate) => setFromDate(newDate)}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </div>
                        </Box>

                        <Box>
                            <div>
                                <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                            </div>
                            <div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker']}>
                                        <DateTimePicker
                                            className={classes.customerAdminDateTimePicker}
                                            sx={{
                                                width: {
                                                    xs: "150px",
                                                    sm: "200px",
                                                    md: "250px"
                                                },
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                }, '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={toDate}
                                            onChange={(newDate) => setToDate(newDate)}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </div>
                        </Box>

                        <div style={{ marginTop: '32px' }}>
                            <Autocomplete
                                options={filterOptions}
                                getOptionLabel={(filterOptions) => filterOptions.label}
                                renderInput={(params) => <TextField {...params} label="Registered Filter" />}
                                value={filterOptions.find((filterOptions) => filterOptions.value === selectedFilterValue) || null}
                                onChange={HandleChangeFilter}
                                disabled={isLoading}
                                className={classes.customerAdminDateTimePicker}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </div>

                        <div onScroll={handleScroll} style={{ marginTop: '32px' }}>
                            <Autocomplete
                                options={getReferCode} // use the state populated with transformed data
                                getOptionLabel={(option) => option.label} // display name and last name as the label
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Refer By"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {IsLoadingRef ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                value={getReferCode.find((option) => option.value === selectedRefer) || null} // selected referral_code
                                onChange={HandleChangeReferedByFilter}
                                disabled={isLoading}
                                ListboxProps={{ onScroll: handleScroll }}
                                onInputChange={handleInputChange}
                                loading={loading}
                                className={classes.customerAdminDateTimePicker}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </div>

                        <div style={{ marginTop: '32px' }}>
                            <TextField
                                value={searchTerm}
                                onChange={handleSearchChange}
                                placeholder="Search Name , Email , Phone "
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClear} aria-label="clear search">
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                                className={classes.customerAdminDateTimePicker}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </div>
                        <div style={{marginTop: '32px'}}>
                        <Box className={classes.handleSearchStyle}>
                            <Button
                                onClick={() => handleSearchClick(searchTerm)}
                                style={{
                                    width: 'auto',
                                    height: '50px',
                                    background: '#336a93',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    marginTop: '6px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: 'white',
                                }}
                            >
                                <SearchIcon
                                    style={{
                                        color: 'white',
                                        margin: '12px',
                                        // fontSize: '21px',
                                        cursor: 'pointer',
                                    }}
                                />
                            </Button>
                            <Button
                                style={{
                                    width: '30px',
                                    height: '50px',
                                    border: '1px solid gray',
                                    background: '#bababa',
                                    borderRadius: '12px',
                                    fontWeight: 'bold',
                                    marginLeft: '6px',
                                    cursor: 'pointer',
                                    marginTop: '6px',
                                    color: 'black',
                                }}
                                sx={{ fontFamily: 'inherit', }}
                                onClick={handleClearAllState}
                            >
                                Clear
                            </Button>
                        </Box>
                    </div>
                    </Box>

                    
                </Box>
                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />
                </ThemeProvider>
                <Box className={classes.MaterialReactTableCustomerSuperAdmin}>
                    <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                        <MaterialReactTable
                            columns={columns}
                            data={GetAllCustomers}
                            state={{ isLoading: isLoading }}
                            muiCircularProgressProps={{
                                color: 'secondary',
                                thickness: 5,
                                size: 55,
                            }}
                            muiSkeletonProps={{
                                animation: 'pulse',
                                height: 28,
                            }}
                            enableTopToolbar={false}
                            enableFacetedValues={true}
                            enableStickyHeader={true}
                            enableDensityToggle={false}
                            enableHiding={false}
                            showSkeletons={false}
                            enableColumnFilterModes={false}
                            enableColumnActions={false}
                            enableColumnOrdering={false}
                            enableFullScreenToggle={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            getRowId={(row) => row.id}
                            initialState={{
                                showColumnFilters: false,
                                showGlobalFilter: false,
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                    backgroundColor: '#f5f5f5', // Default row background color
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: '#ffffff', // Alternate rows with white
                                    },
                                    '&:hover': {
                                        backgroundColor: '#e0e0e0', // Hover effect
                                        cursor: 'pointer'
                                    },
                                },
                            }}
                        />
                    </Card>
                    <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                    />
                </Box>
            </Box>

            {/* DeleteModal */}
            <Modal open={openDeleteModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box
                            sx={{
                                display: 'grid',
                                padding: '10px',
                                gap: '10px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <DeleteIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this Customer?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>
                                            This action will delete this customer permanently, and you can not undo this.
                                        </span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleCloseDeleteModal}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                            >
                                Delete
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>

            {/* confirmation modal for Customer switch */}
            <Dialog open={openConfirmationMandatory} TransitionComponent={Transition} keepMounted aria-describedby="alert-dialog-slide-description">
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to switch this customer to a agent.?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmationMandatory(false)}>NO</Button>
                    <Button onClick={handleConfirmationMandatory} disabled={switchLoading}> {switchLoading ? 'Processing...' : 'YES'}</Button>
                </DialogActions>
            </Dialog>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </div>
    );
};
export default CustomersAdmin;
